import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { AdminAuditEntry } from '../models/admin-audit.model';

export interface AdminAuditFilterParams {
  /**
   * Filtre logique côté FRONTEND uniquement.
   * Valeurs : AFFECTATION | RETRAIT | CREATE | UPDATE | SUPPRESSION
   *
   * ⚠️  Ces valeurs sont des labels métier produits par le backend après transformation
   * des admin-events Keycloak. Le backend Keycloak ne connaît que CREATE/UPDATE/DELETE.
   * Ce paramètre N'EST DONC PAS envoyé en query param HTTP — le filtrage se fait
   * en mémoire dans AdminAuditComponent.applyFilters().
   */
  operationType?: string;

  /**
   * Nom d'affichage de l'admin (valeur du champ `auteur`).
   * Filtrage effectué CÔTÉ FRONTEND en mémoire pour la même raison.
   */
  adminId?: string;

  /**
   * Timestamp de début en millisecondes (epoch ms).
   * Envoyé en query param si l'API /admin-audit le supporte.
   * Sinon, le filtrage est effectué côté frontend via applyFilters().
   */
  startDateMs?: number;

  /**
   * Timestamp de fin en millisecondes (epoch ms).
   */
  endDateMs?: number;
}

@Injectable({
  providedIn: 'root'
})
export class AdminAuditService {
  private readonly baseUrl = `${environment.apiUrl}/admin-audit`;

  constructor(private http: HttpClient) {}

  /**
   * Récupère tous les événements d'audit.
   *
   * Les filtres operationType, adminId et date sont gérés CÔTÉ FRONTEND
   * car l'API /admin-audit retourne des valeurs métier (AFFECTATION, RETRAIT…)
   * que Keycloak ne connaît pas nativement.
   *
   * Seuls les paramètres réellement supportés par l'API sont envoyés.
   */
  getAdminAudit(): Observable<AdminAuditEntry[]> {
    return this.http.get<AdminAuditEntry[]>(this.baseUrl);
  }
}